var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.832 156.85C149.304 156.85 184.545 121.738 184.545 78.4248C184.545 35.112 149.304 0 105.832 0C62.3601 0 27.1191 35.112 27.1191 78.4248C27.1191 121.738 62.3601 156.85 105.832 156.85Z",
    fill: "#072F73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0504 200C71.402 200 83.847 187.601 83.847 172.305C83.847 157.01 71.402 144.61 56.0504 144.61C40.6988 144.61 28.2539 157.01 28.2539 172.305C28.2539 187.601 40.6988 200 56.0504 200Z",
    fill: "#0096FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6558 150.163C42.7825 150.163 48.5597 144.406 48.5597 137.306C48.5597 130.205 42.7825 124.449 35.6558 124.449C28.5292 124.449 22.752 130.205 22.752 137.306C22.752 144.406 28.5292 150.163 35.6558 150.163Z",
    fill: "#C5D9FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.45 164.854L166.403 136.271C164.72 130.297 160.026 125.638 154.027 123.982L121.922 115.121C118.577 114.199 117.446 110.04 119.87 107.562L142.873 84.0559C147.257 79.5757 148.944 73.1223 147.311 67.0819L139.724 39.0117L54.4717 62.3639L62.3555 90.3549C64.0512 96.3786 68.8117 101.067 74.8784 102.682L106.707 111.167C110.061 112.059 111.224 116.21 108.825 118.709L85.7768 142.674C81.4685 147.154 79.8273 153.549 81.4476 159.54L89.1974 188.206L174.45 164.854Z",
    fill: "url(#paint0_linear_9212_59930)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.712 31.1601L49.598 56.1139C48.2603 56.4803 47.4739 57.8579 47.8416 59.1907L49.5206 65.2765C49.8884 66.6094 51.271 67.3929 52.6087 67.0265L143.722 42.0727C145.06 41.7063 145.846 40.3288 145.479 38.9959L143.8 32.9101C143.432 31.5772 142.049 30.7937 140.712 31.1601Z",
    fill: "#1968F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.31 160.197L85.1967 185.151C83.8589 185.517 83.0725 186.895 83.4403 188.228L85.1193 194.314C85.487 195.647 86.8696 196.43 88.2074 196.064L179.321 171.11C180.659 170.743 181.445 169.366 181.077 168.033L179.398 161.947C179.031 160.614 177.648 159.831 176.31 160.197Z",
    fill: "#1968F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1741 83.9769L67.9152 86.6133C69.3681 91.7693 73.4419 95.7782 78.6336 97.1631L97.9015 102.302L108.737 105.197C111.006 105.802 113.426 105.139 115.063 103.466L125.346 92.9457L136.814 81.2279C140.566 77.3942 142.01 71.8711 140.612 66.7026L139.896 64.062C139.443 62.3892 137.714 61.4048 136.035 61.8636L69.3555 80.1266C67.6808 80.5855 66.6968 82.3166 67.1658 83.9811L67.1741 83.9769Z",
    fill: "#1968F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.242 125.587L112.525 132.099C111.958 133.092 112.306 134.355 113.303 134.92L119.839 138.624C120.836 139.189 122.104 138.842 122.671 137.849L126.389 131.337C126.956 130.343 126.607 129.08 125.611 128.515L119.074 124.811C118.077 124.246 116.809 124.593 116.242 125.587Z",
    fill: "#1968F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9212_59930",
    x1: 112.009,
    y1: 49.1986,
    x2: 117.251,
    y2: 186.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F2F6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E2ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CBDDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D9FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/Hourglass.077e3b1120a5e4718d8aade4c19fb727.svg";
export { ForwardRef as ReactComponent };